import { render, staticRenderFns } from "./StorePay.vue?vue&type=template&id=4479c3aa&scoped=true&"
import script from "./StorePay.vue?vue&type=script&lang=js&"
export * from "./StorePay.vue?vue&type=script&lang=js&"
import style0 from "./StorePay.vue?vue&type=style&index=0&id=4479c3aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4479c3aa",
  null
  
)

export default component.exports